import React from "react";
import {Helmet} from "react-helmet";

export default function FastYetSlow() {
    return (
        <div>
            <Helmet>
                <title>又快又慢 Fast Yet Slow</title>
            </Helmet>
            <h6 className="App-essay-title">又快又慢</h6>
            <p className="App-essay-article">
                <br/>
                <b>二〇二五 五月</b>
                <br/><br/>
                大小两个铅球，一个重一个轻，同时从比萨斜塔上扔下来。谁先落地。
                <br/><br/>
                作为伽利略的知名实验，文艺复兴的高光时刻，我们知道结论。但让我们先忘记这个结论，并暂缓扔铅球的计划。一起做个思想实验。
                <br/><br/>
                直观来看，重的东西比轻的东西下落速度快，但让我们把这两个球绑在一起看：
                <br/><br/>
                <ol>
                    <li>大铅球多绑了一个小铅球，总重量变得更大，所以两个球绑在一起比大铅球本身下落得快</li>
                    <li>小铅球下落速度比大铅球慢，所以绑在一起大铅球会被小铅球拖后腿，于是两个球绑在一起比大铅球本身下落得慢</li>
                </ol>
                如果重的东西比轻的东西下落速度快，我们就会得出大球变得“又快又慢”的悖论。
                <br/><br/>
                当然，我们也可以相信“轻的东西比重的下落速度快”这种反直觉的假设，于是也会有：
                <br/><br/>
                <ol>
                    <li>大铅球多绑了一个小铅球，总重量变得更大，所以两个球绑在一起比大铅球本身下落得慢</li>
                    <li>小铅球下落速度更快，所以绑在一起大铅球会被小铅球加速，于是两个球绑在一起比大铅球本身下落得快</li>
                </ol>
                只要假设大小铅球下落速度有快慢，就都会出现悖论。所以，事实极可能是另一种，大球既不比小球快，也不比小球慢，它们下落速度一样。
                <br/><br/>
                古希腊人早就用直觉反证了两者降落速度必须一致，但伽利略在比萨斜塔的落球实验无疑让旁观群众，有了震撼的视觉感观。
                <br/><br/>
                把一个自己（灵魂）和另一个自己（现实）绑在一起，就正如我们每天出门的样子。如果其中一个比另一个走得更快或更慢，那么逻辑上就会重复选项1和2。
                <br/><br/>
                只要灵魂和现实的速度不一致，就会出现光怪陆离的景象。


            </p>

            <br/>

            <h6 className="App-essay-title">Fast Yet Slow</h6>
            <p className="App-essay-article">
                <br/>
                <b>May 2025</b>
                <br/><br/>

            </p>
        </div>)
}
